export default [
  {
    title: "Lucky Draw",
    customIcon: "LotterySVG",
    children: [
      {
        title: "Lucky Draw",
        route: "lucky-draw-campaign-list",
        path: "/lucky-draw/campaign/list",
      },
      {
        title: "Winner Anouncement",
        route: "winner-anouncement-campaign-list",
        path: "/winner-anouncement/campaign/list",
      },
    ],
  },
];
